import { useContext } from 'react'
import { ModalContext } from '@sketch/components'
import ShareSettingsModal, {
  ShareMinimalForSettingsModal,
} from 'modules/shares/modals/ShareSettingsModal'

export const useSharingModal = (share: ShareMinimalForSettingsModal) => {
  const { showModal } = useContext(ModalContext)

  const openShareSettingsModal = (options?: { closeOnRouteChange: boolean }) =>
    showModal(ShareSettingsModal, { share }, options)

  return { openShareSettingsModal }
}
